import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { ROUTES_CONSTANTS } from "../constants";

const BackToSignIn = ({ className = "" }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <button
      className={`font-medium text-sm cursor-pointer transition whitespace-nowrap ${className}`}
      onClick={() => navigate(ROUTES_CONSTANTS.LOGIN)}
    >
      <span className="text-black">{t("common.backTo")} </span>
      <span className="text-primary-500">{t("common.signIn")}</span>
    </button>
  );
};

export default BackToSignIn;
